import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  Avatar,
} from '@mui/material';
import { Block as BlockIcon, Home as HomeIcon } from '@mui/icons-material';

export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minHeight: '60vh',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            maxWidth: 500,
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'error.main', width: 56, height: 56 }}>
            <BlockIcon sx={{ fontSize: 32 }} />
          </Avatar>
          
          <Typography component="h1" variant="h4" gutterBottom align="center">
            Zugriff verweigert
          </Typography>
          
          <Typography variant="body1" color="textSecondary" align="center" paragraph>
            Sie haben nicht die erforderlichen Berechtigungen, um auf diese Seite zuzugreifen.
          </Typography>

          <Typography variant="body2" color="textSecondary" align="center" paragraph>
            Wenn Sie glauben, dass dies ein Fehler ist, wenden Sie sich bitte an Ihren Administrator.
          </Typography>

          <Button
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={handleGoHome}
            sx={{ mt: 2 }}
          >
            Zur Startseite
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};